export default "__VITE_ASSET__CmzU0jgS__"